require('../shared/inactiveSubscriptionOverlay/inactiveSubscriptionOverlayDirective');

'use strict';

angular.module('app.myHockeyTv.myHockeyTvController', [
  'app.currentUser',
  'app.shared.inactiveSubscriptionOverlay.inactiveSubscriptionOverlayDirective'
  ])
  .controller('app.myHockeyTv.myHockeyTvController', [
      '$scope', '$state', 'currentUser',
      function ($scope, $state, currentUser) {
          $scope.state = $state;
          if(currentUser.has_access() || currentUser.is_pass_holder()) {
            $scope.has_access = true;
          }
      }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/myHockeyTvController.js